
import calendarsIntegrationAPI from '@/logic/api/calendarsIntegration';
import router from '@/router';
import store from '@/store';

export default {
  name: 'CalendarTokenHandler',

  created() {
    this.pushTokenToTheBE();
  },

  methods: {
    async pushTokenToTheBE(): Promise<void> {
      const token = this.$route.query.code;
      const source = this.$route.query.scope;

      const request = source?.includes('googleapis')
        ? calendarsIntegrationAPI.postGoogleToken
        : calendarsIntegrationAPI.postMicrosoftToken;

      const resp = await request(token);

      if (resp.ok) {
        localStorage.setItem('userRespondedToCalendarsConnectionModal', 'true');
        router.push(this.getDestinationPath());
      } else if (resp.status !== 401) this.$message.error(this.$t('someErrorOccurred'));
    },

    getDestinationPath(): string {
      let path = '';
      const userRole = store.state.userRole;

      if (userRole === 'assessor') path = '/assessor-tasks';
      else if (userRole === 'client') path = '/client-tasks';
      else path = `/assessment-timeline?id=${localStorage.getItem('recentAssessmentAsCand')}`;

      return path;
    },
  },
};
